/**
 * aggregator-failure-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateOpaqueID, validateTSEnum }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { ResponseCode } from "../general/response-code";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_AGGREGATOR_FAILURE)
export class AggregatorFailureResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_AGGREGATOR_FAILURE;

  @validateOpaqueID()
  public aggregationId : number;

  @validateTSEnum(ResponseCode)
  public code : ResponseCode;

  @validateAs("string")
  public reason : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/aggregator-failure-response.ts